module.exports = __webpack_public_path__ + "static/img/next-game3.114cfe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/next-game3.png
// module id = wuvb
// module chunks = 0